import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerificationPage from "../../../components/VerificationPage";
import {
  companySendCode,
  registerCompany,
} from "../../../services/company/authenticationApiFn";
import { encryptPassword, handleOpenSnackBar } from "../../../utils";

const CompanyRegistrationVerification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { inputValues } = state;
  const [code, setCode] = useState();
  const [isLoading, setIsLoading] = useState("");

  const handleVerify = async () => {
    const longitude = inputValues.companyLocation?.lng;
    const latitude = inputValues.companyLocation?.lat;

    const locationObject = {
      addressLabel: inputValues.location.label,
      formatedAddress: inputValues?.companyLocation?.address,
      type: "Point",
      coordinates: [longitude, latitude],
    };

    const payload = {
      name: inputValues.name,
      email: inputValues.email,
      contact: inputValues.contact,
      location: locationObject,
      expertise: inputValues.source,
      profileImg: inputValues.image,
      licenseImg: inputValues.license,
      password: encryptPassword(inputValues.password),
      role: "Company",
      otp: code,
      cui: inputValues.cui,
    };

    try {
      setIsLoading(true);
      const response = await registerCompany(payload);
      if (response.data.status === "success") {
        const data = response.data.data;
        navigate("/subscriptions", {
          state: { type: "company", user: data?._id },
        });
        setCode("");
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendCode = async () => {
    try {
      setIsLoading(true);
      const payload = {
        email: inputValues.email,
        purpose: "Registration",
        role: "Company",
        cui: inputValues.cui,
      };
      const response = await companySendCode(payload);
      if (response.data.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <VerificationPage
      handleBack={() => {
        navigate("/register/company", { state: { inputValues } });
      }}
      code={code}
      setCode={setCode}
      handleClickBtn={handleVerify}
      isLoading={isLoading}
      handleSendCode={handleSendCode}
    />
  );
};

export default CompanyRegistrationVerification;
